import CADMPDFGeneration from 'components/CADMPDFGeneration';

export const publicRoutes = [
  {
    id: 'cadmPDFGeneration',
    basePath: '/cadm-pdf-generation',
    path: '/cadm-pdf-generation/:vendorOpportunityId',
    component: CADMPDFGeneration,
  },
];
